import { render, staticRenderFns } from "./default.vue?vue&type=template&id=44532960"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./default.vue?vue&type=style&index=0&id=44532960&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "c9881f1a"
  
)

export default component.exports